const getters = {
  showImgSelect: state => state.media.showImgSelect,
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js